import moment from 'moment';
import { getValueFromLocalStorage, STORAGE_KEY } from './localStorageService';
import { formatToPercentage } from './stringUtility';
import { globalConstants, staticCommonLabelKeys } from '../moduleConstants';
import { renderCurrencyWithSymbol } from './currencyFormatUtility';

const { dateFormatMMDDYYYY } = globalConstants;

export const COLUMN_DATA_TYPE = {
  default: 0,
  string: 1,
  date: 2,
  with2PrecisionAndParens: 3,
  yesNo: 4,
  withCurrency2PercisionAndParens: 5,
  percentage: 6,
  withPercent4Percision: 7,
};

export const getDateFormat = (value) => {
  if (value) {
    const dateFormat = getValueFromLocalStorage(STORAGE_KEY.DATE_FORMAT) || dateFormatMMDDYYYY;
    const trimedDateStr = String(value).trim();
    return moment(trimedDateStr).format(dateFormat);
  }
  return null;
};

export const formatYesNo = (value, t) => (value === 1
  ? t(staticCommonLabelKeys.COMMON_BUTTON_YES)
  : t(staticCommonLabelKeys.COMMON_BUTTON_NO));
const numberTwo = 2;
const numberFour = 4;
export const formatFieldWithDataType = ({ value, dataType, locale }) => {
  switch (dataType) {
    case COLUMN_DATA_TYPE.date:
      return getDateFormat(value);
    case COLUMN_DATA_TYPE.percentage:
      return formatToPercentage(value);
    case COLUMN_DATA_TYPE.withPercent4Percision:
      return formatToPercentage(value, numberFour);
    case COLUMN_DATA_TYPE.withCurrency2PercisionAndParens:
    case COLUMN_DATA_TYPE.with2PrecisionAndParens:
      return renderCurrencyWithSymbol(value, locale, numberTwo);
    default:
  }

  return value;
};
